module.exports = __webpack_public_path__ + "files/8ad46046dc1a879f677aba69251a794c.png";